export default "__VITE_ASSET__DoRqVUZx__"